import Box, { BoxProps } from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import ReactHtmlParser from "react-html-parser";

interface IContractText {
  template: string;
}

const MandateText: FC<IContractText & BoxProps> = (props) => {
  return (
    <Box {...props}>
      <Typography>
        {ReactHtmlParser(props.template) as React.ReactNode}
      </Typography>
    </Box>
  );
};

export default MandateText;
